export default __webpack_public_path__ + "static/media/TNS-Web-Banners5.c4416b6c.png";